import { Trans } from 'react-i18next'

const Sustentable = () => {
  return (
    <div className="sustentable">
      <div className="container" data-aos="fade">
        <h4 className="sus__title col-md-5 col-sm-12">
          <Trans i18nKey="sustentable.title" />
        </h4>
        <div className="col-md-5">
          <div className="separador"></div>
          <div className="step">
            <div className="step__num">
              <p>1</p>
            </div>
            <div className="step__text">
              <p>
                <Trans i18nKey="sustentable.steps.step1" />
              </p>
            </div>
          </div>
          <div className="separador"></div>
          <div className="step">
            <div className="step__num">
              <p>2</p>
            </div>
            <div className="step__text">
              <p>
                <Trans i18nKey="sustentable.steps.step2" />
              </p>
            </div>
          </div>
          <div className="separador"></div>
          <div className="step">
            <div className="step__num">
              <p>3</p>
            </div>
            <div className="step__text">
              <p>
                <Trans i18nKey="sustentable.steps.step3" />
              </p>
            </div>
          </div>
          <div className="separador"></div>
        </div>
      </div>
    </div>
  )
}

export default Sustentable
